var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5V28.5C10.5 28.8978 10.342 29.2794 10.0607 29.5607C9.77936 29.842 9.39782 30 9 30H6C5.60218 30 5.22064 29.842 4.93934 29.5607C4.65804 29.2794 4.5 28.8978 4.5 28.5V18C4.5 17.6022 4.65804 17.2206 4.93934 16.9393C5.22064 16.658 5.60218 16.5 6 16.5H10.5ZM10.5 16.5C12.0913 16.5 13.6174 15.8679 14.7426 14.7426C15.8679 13.6174 16.5 12.0913 16.5 10.5V9C16.5 8.20435 16.8161 7.44129 17.3787 6.87868C17.9413 6.31607 18.7044 6 19.5 6C20.2956 6 21.0587 6.31607 21.6213 6.87868C22.1839 7.44129 22.5 8.20435 22.5 9V16.5H27C27.7956 16.5 28.5587 16.8161 29.1213 17.3787C29.6839 17.9413 30 18.7044 30 19.5L28.5 27C28.2843 27.9202 27.8751 28.7104 27.334 29.2514C26.7929 29.7925 26.1493 30.0552 25.5 30H15C13.8065 30 12.6619 29.5259 11.818 28.682C10.9741 27.8381 10.5 26.6935 10.5 25.5",
    stroke: "#F74439",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumbUp.fb3ba39ccf2e9853b89ab65b0c20aeec.svg";
export { ForwardRef as ReactComponent };